import React from 'react';
import BaseEditPage from "../../Base/BaseEditPage";
import * as f from "../../common/Funcs";

const keyName = 'SpecViewPage';
export default class SpecViewPage extends BaseEditPage {
    constructor(props) {
        super(props);
        const context = this;
        context.state = {rowId: null, columns: [], data: {}};
        if (window.IasConfig.devMode) console.debug(`${keyName} constructor`, arguments);
        context.tableName = 'specView';
        context.idName = 'spec_id';
        context.titleName = 'name_rus';
        context.rowId = context.props.rowId || document.getCookie(context.tableName);
        context.footerButtonNames = [];
        context.fieldsSet = [
            {title: 'Характеристики', fieldset: 'char'},
        ];
//        !!!реализовать группировку в строкаъ
        context.columnsDefaults = [...context.lastUserColumns, ...[
            {column_name: 'spec_rang', hidden: true},
            {column_name: 'spec_parent', hidden: true},
            {column_name: 'name_lat', row: 10, pos: 1},
            {column_name: 'name_rus', row: 10, pos: 2},
            {column_name: 'spec_desc', row: 30, pos: 2, column_width: 1000},
            {column_name: 'spec_id', hidden: true},
            {column_name: 'sys_group', hidden: true},
            {column_name: 'hunting_object', row: 20, pos: 3},
            {column_name: 'water_resource', row: 20, pos: 4},
            {column_name: 'is_bird', row: 20, pos: 5},
            {column_name: 'sys_rus', hidden: false, row: 0, pos: 0, height: '55px', minWidth: '100%'},
            {column_name: 'flora_type', row: 40, pos: 0},
        ]];
        context.subTables = [
            {
                title: 'Синонимы',
                pos: 2,
                elementName: 'BaseSubGridPanel',
                subName: 'SynonimSub',
                tableName: 'species',
                subElementName: null,
                filterString: "spec_parent=$spec_id$",
                idName: 'spec_id',
                hiddenColumns: ['spec_id', 'spec_parent', 'spec_rang'],
                noSingle: true,
                fieldset: 'syn'
            }, //синонимы
            {
                title: 'Литературные источники',
                pos: 2,
                elementName: 'BaseRelationSub',
                subName: 'LitSourceSub',
                tableName: 'speclit',
                subElementName: null,
                relation: {tableName: 'spec_lit', parentField: 'spec_id', relField: 'id_lit_source'},
                filterString: "spec_id=$spec_id$",
                noSingle: true,
                idName: 'spec_id',
                hiddenColumns: ['spec_id', 'id_lit_source'],
                fieldset: 'lit'
            }, //лит. источники
            {
                title: 'В Красной Книге',
                pos: 3,
                elementName: 'BaseSubGridPanel',
                subName: 'RedBookSub',
                tableName: 'specrb',
                subElementName: null,
                relation: {tableName: 'spec_rb', parentField: 'spec_id', relField: 'rb_id'},
                noSingle: true,
                filterString: "spec_id=$spec_id$",
                idName: 'row_id',
                hiddenColumns: ['row_id', 'spec_id', 'rb_id'],
            }, //КК
            {
                title: 'Актуальный статус вида',
                pos: 3,
                elementName: 'BaseSubGridPanel',
                subName: 'SpecStatusSub',
                tableName: 'spec_status',
                noSingle: true,
                subElementName: null,
                activeColumn: 'status_active',
                filterString: "spec=$spec_id$",
                idName: 'row_id',
                rowHeight: 100,
                columnsDefaults: [...context.lastUserColumns, ...[
                    {column_name: keyName},
                    {column_name: "status_active", row: 0, pos: 0},
                    {column_name: "spec_area", hidden: true, row: 0, pos: 10, className: 'copy-class'},
                    {column_name: "spec_count", pos: 0, row: 1, maxWidth: 150, className: 'copy-class'},
                    {column_name: "spec_state", pos: 2, row: 1, className: 'copy-class'},
                    {column_name: "spec_habitat_structure", hidden: true, pos: 3, row: 1, className: 'copy-class'},
                    {column_name: "spec_habitat_quality", hidden: true, pos: 3, row: 1, className: 'copy-class'},
                    {column_name: "spec_habitat_area", hidden: true, pos: 3, row: 1, className: 'copy-class'},
                    //          {column_name: "phones", hidden: true, row: 2, pos: 4, className: 'copy-class',},
                    //         {column_name: "emails", hidden: true, row: 3, pos: 5, className: 'copy-class',}
                ]],
                tpl: (data) => {
                    return (
                        <div className={'spec-status-tpl'}>
                            <div className={'tpl-row copy-container'}>
                                <span className={'tpl-title'}>Ареал обитания: </span>
                                <div className={'copy-class x-gridcell '}>
                                    <span className={'tpl-text'}>{data.spec_area}</span>
                                    <div className="x-after-input-el"/>
                                </div>
                            </div>
                            <div className={'tpl-row copy-container'}>
                                <span className={'tpl-title'}> Описание ареала: </span>
                                <div className={'copy-class x-gridcell '}>
                                    <span className={'tpl-text'}>{data.spec_habitat_area}</span>
                                    <div className="x-after-input-el"/>
                                </div>
                            </div>
                            <div className={'tpl-row copy-container'}>
                                <span className={'tpl-title'}> Структуры ареала: </span>
                                <div className={'copy-class x-gridcell '}>
                                    <span className={'tpl-text'}>{data.spec_habitat_structure}</span>
                                    <div className="x-after-input-el"/>
                                </div>
                            </div>
                            <div className={'tpl-row copy-container'}>
                                <span className={'tpl-title'}> Условия обитания: </span>
                                <div className={'copy-class x-gridcell '}>
                                    <span className={'tpl-text'}>{data.spec_habitat_quality}</span>
                                    <div className="x-after-input-el"/>
                                </div>
                            </div>
                        </div>
                    )
                }
            }, //КК
            {
                title: 'Фотографии',
                pos: 3,
                elementName: 'BaseSubGridPanel',
                subName: 'SpecPhotosSub',
                tableName: 'spec_photo',
                noSingle: true,
                filterString: "spec=$spec_id$",
                idName: 'photo_id',
                rowHeight: 100,
                columnsDefaults: [...context.lastUserColumns, ...[
                    {column_name: "spec", hidden: true, row: 0, pos: 0},
                    {column_name: "photo_id", hidden: true, pos: 0},
                    {column_name: "photo_name", title: true, pos: 0, className: 'copy-class'},
                ]],
                tpl: (data) => {
                    return <div></div>
                }
            }, //КК
            {
                title: 'История изменений',
                elementName: 'CardLogSub',
                collapsed: true,
                noSingle: true,
                subElementName: 'LogPage',
                hidden: () => !f.isAdmin(),
                filterString: "table_name ='species' and record_id = $spec_id$::varchar",
            }
        ]
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const context = this;

        if (!context.state.rowId && context.state.columns.length > 0) {
            return context.setState({columns: []});
        }
        if (prevState.rowId != context.state.rowId) {
            context.rowId = context.state.rowId;
            context.getData({context});
        }
    }

    getToolBar(context, buttons) {
        return '';
    }
}


